import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const createReferenceDataValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    domain: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_XXS, i18n.t("validation.charCount.invalid.50")),
    id: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_20, i18n.t("validation.charCount.invalid.20")),
    name: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    index: yup.number().typeError(i18n.t("m.validation.number")).required(),
    isActive: yup.boolean().required(),
  });
};
